import styled, { css, StyledComponent } from 'styled-components';
import { EStatusStr } from '@src/emp-3.0/types';

export const Wrapper = styled.div`
  padding: 0 16px;
`;

export const MetricInfo = styled.div`
  display: flex;
  padding: 16px;
  padding-left: 35px;
  gap: 16px;
  border-bottom: 1px solid #d9d9d9;
`;

export const InfoCardContainer: StyledComponent<'div', any, {}, never> = styled.div`
  display: flex;
  padding: 6px 8px;
  flex-direction: column;
  align-items: flex-start;
`;

export const InfoLabel = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-family: Roboto, sans-serif;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 4px;
`;

export const InfoValue: StyledComponent<'div', any, {}, never> = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 20px;
`;
